import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"media"}},[_c('h2',[_vm._v("MEDIA")]),_c('ul',{staticClass:"media-info"},_vm._l((_vm.media),function(item){return _c('li',{key:item.link},[_c('a',{staticClass:"circle",attrs:{"href":item.link,"target":"_blank"}},[_c(VIcon,[_vm._v(" "+_vm._s(item.icon)+" ")])],1)])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }